import { useAuth } from "../contexts/AuthContext";

export interface AuthStatus {
  isAuthenticated: boolean;
  isOnboarded: boolean;
  isLoading: boolean;
  user: any;
  error: string | null;
  canAccessApp: boolean;
  needsOnboarding: boolean;
}

/**
 * Custom hook that provides a clean interface for checking auth status
 * This is the recommended way for components to check auth state
 */
export const useAuthStatus = (): AuthStatus => {
  const {
    isAuthenticated,
    isOnboarded,
    loading,
    onboardingLoading,
    user,
    error,
  } = useAuth();

  const isLoading = loading || onboardingLoading || isOnboarded === null;
  const canAccessApp = isAuthenticated && isOnboarded === true;
  const needsOnboarding = isAuthenticated && isOnboarded === false;

  return {
    isAuthenticated,
    isOnboarded: isOnboarded ?? false,
    isLoading,
    user,
    error,
    canAccessApp,
    needsOnboarding,
  };
};
